import { Link, LinkProps } from '@mui/material';

interface CollectionLearnMoreLinkProps {
  linkProps?: LinkProps;
  label?: string;
}

const COLLECTION_HELP_CENTER_LINK =
  'https://helpcenter.enterpret.com/en/articles/9317264-collections';

export const CollectionLearnMoreLink = ({
  linkProps,
  label,
}: CollectionLearnMoreLinkProps) => {
  return (
    <Link href={COLLECTION_HELP_CENTER_LINK} target="_blank" {...linkProps}>
      {label ?? 'Learn more'}
    </Link>
  );
};
